import { useEffect } from 'react'
import { App, URLOpenListenerEvent } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { useNavigate } from 'react-router'
import { getDeepLinkPath } from './utils.ts'

// Used for deep links
const AppUrlListener = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // appUrlOpen only fires natively; on the web the listener only lazy-loads the plugin's web chunk
    if (!Capacitor.isNativePlatform()) return

    const listener = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const path = getDeepLinkPath(event.url)

      if (path) {
        void navigate(path)
      }
    })

    return () => {
      void listener.then((handle) => handle.remove())
    }
  }, [navigate])

  return null
}

export default AppUrlListener
